<template>
  <div>
    <div class="navbar-wrapper">
      <div class="container">

        <nav class="navbar navbar-inverse navbar-static-top">
          <div class="container">
            <div class="navbar-header">
              <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <a class="navbar-brand" href="/">
                山东昱晟玻璃制品有限公司
                <!-- <img src="/image/image/LOGO.gif" alt=""> -->
              </a>
            </div>
            <div id="navbar" class="navbar-collapse collapse">
              <ul class="nav navbar-nav">
                <li :class="nowRoute == '/' ? 'active' : ''">
                  <router-link :to="'/'">首页</router-link>
                </li>
                <li class=" dropdown" :class="nowRoute.indexOf('product') > -1 || nowRoute.indexOf('detail') > -1 ? 'active': '' ">
                  <a href="javascript:;;" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                    公司产品 
                    <span class="caret"></span>
                  </a>
                  <ul class="dropdown-menu">
                    <li :class="nowRoute.indexOf('bosidun') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=bosidun'">波斯顿瓶 / 瓶盖</router-link>
                    </li>

                    <li :class="nowRoute.indexOf('guangkou') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=guangkou'">广口瓶系列</router-link>
                    </li>

                    <li :class="nowRoute.indexOf('gunzhu') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=gunzhu'">滚珠瓶</router-link>
                    </li>

                    <li :class="nowRoute.indexOf('koufuye') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=koufuye'">口服液瓶</router-link>
                    </li>

                    <li :class="nowRoute.indexOf('lvgai') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=lvgai'">铝盖系列
                      </router-link>
                    </li>
                    <li :class="nowRoute.indexOf('lvsejingyou') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=lvsejingyou'">绿色精油瓶
                      </router-link>
                    </li>
                    <li :class="nowRoute.indexOf('mokang') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=mokang'">模抗瓶
                      </router-link>
                    </li>
                    <li :class="nowRoute.indexOf('pijiu') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=pijiu'">啤酒瓶
                      </router-link>
                    </li>
                    <li :class="nowRoute.indexOf('toumingjingyou') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=toumingjingyou'">透明精油瓶
                      </router-link>
                    </li>
                    <li :class="nowRoute.indexOf('toumingmukang') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=toumingmukang'">透明模抗瓶
                      </router-link>
                    </li>
                    <li :class="nowRoute.indexOf('zongsejingyou') > -1 ? 'active': '' ">
                      <router-link :to="'/product/list?type=zongsejingyou'">棕色精油瓶
                      </router-link>
                    </li>
                  </ul>
                </li>

                <li :class="nowRoute == '/technology/index' ? 'active': '' ">
                  <router-link :to="'/technology/index'">生产工艺</router-link>
                </li>

                <li :class="nowRoute == '/about/index' ? 'active': '' ">
                  <router-link :to="'/about/index'">公司简介</router-link>
                </li>

                <li :class="nowRoute == '/contact/index' ? 'active': '' ">
                  <router-link :to="'/contact/index'">联系我们</router-link>
                </li>

              </ul>
            </div>
          </div>
        </nav>

      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import jQuery from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
export default {
  data() {
    return {
      nowRoute: '',
    }
  },
  watch: {
    '$route.fullPath': function (val) {
      this.changeRoute()
    },
  },
  created() {
    this.changeRoute()
  },
  methods: {
    changeRoute() {
      this.nowRoute = this.$route.fullPath
    },
  },
}
</script>

<style>
</style>